import { BodyWrapper } from './body.component';

export * from './body.component';
export default BodyWrapper;

BodyWrapper.define('der-ui-body-wrapper');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-body-wrapper': BodyWrapper;
    }
}
